import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CrashRecoveryModalComponent } from './crash-recovery-modal.component';

/**
 * Standalone-style module so the crash-recovery modal can be used by both
 * the desktop shell (lazy-loaded `DesktopModule`) and the default layout
 * (eagerly-loaded `AppModule`) without forcing one to import the other.
 *
 * The modal is unconditionally rendered in each layout — only one is in
 * the DOM at any time since the router picks one layout per route, and
 * the modal only ever opens when `CrashRecoveryService` emits, which is
 * at most once per session.
 */
@NgModule({
    declarations: [CrashRecoveryModalComponent],
    imports: [CommonModule],
    exports: [CrashRecoveryModalComponent],
})
export class CrashRecoveryModalModule {}
